import axios from "axios";
import VueCookies from "vue-cookies";

const client = axios.create({
  baseURL:
    process.env.VUE_APP_BASE_URL || "https://api.gurmanlogistics.com/api",
  headers: { "Content-Type": "application/json" },
});

client.interceptors.request.use(
  (config) => {
    const token = VueCookies.get("access_token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error),
);

client.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error && error.response && error.response.status === 401) {
      VueCookies.remove("access_token");
      window.location.hash = "#/login";
    }
    return Promise.reject(error);
  },
);

export default client;
